import React, { useState, useEffect, useCallback } from "react";
import Menu from "../components/menu";
import Categories from "../components/slider";
import { MenuProvider, useMenuContext } from "../store/order_context";
import { useAppContext } from "../store/app_context";
import Items from "../components/items";
import OrderMenu from "../components/order_menu";
import { useUserContext } from '../store/user_context';
import OrderMenuTimeOut from "../components/OrderMenuTimeOut";

const Body = () => {
    const { user } = useUserContext();
    const { setTotalMonthPrice, setOrderTimeSettings } = useAppContext();
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(null);

    // Timer logic is handled inside BodyContent where context is available

    const apiUrl = import.meta.env.VITE_API_URL;
    const otherVariable = user?.userId
        ? `${import.meta.env.VITE_get_today_menu}?userId=${user.userId}`
        : null;

    const fetchMenuData = useCallback(async () => {
        if (!otherVariable) return;

        setIsLoading(true);
        setIsError(null);

        try {
            const response = await fetch(apiUrl + otherVariable, {
                headers: { "Content-Type": "application/json" }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }

            const result = await response.json();
            setData(result);
        } catch (error) {
            setIsError(error.message);
        } finally {
            setIsLoading(false);
        }
    }, [apiUrl, otherVariable]);

    useEffect(() => {
        fetchMenuData();
    }, [fetchMenuData]);

    // Update totals in both Layout props (legacy) and global AppContext once
    useEffect(() => {
        if (data) {
            
            setTotalMonthPrice(data.totalMonthPrice ?? 0);
            setOrderTimeSettings(data.orderTimeSettings ?? null);
        }
    }, [data, setTotalMonthPrice, setOrderTimeSettings]);

    // Interval and timeout state moved to BodyContent

    const handleOrderSuccess = () => {
        // Refetch data after successful order
        fetchMenuData();
    };

    if (isLoading) {
        return (
            <section className="loading-message">
                <p>Loading menu data...</p>
            </section>
        );
    }

    if (isError) {
        return (
            <section className="loading-message">
                <p>Something went wrong loading menu data</p>
            </section>
        );
    }

    if (!data) {
        return (
            <section className="loading-message">
                <p>No menu data available</p>
            </section>
        );
    }

    const BodyContent = () => {
        const { menus, orderTimeSettings } = useMenuContext();

        const [endTimeRemaining, setEndTimeRemaining] = useState(
            typeof orderTimeSettings?.remainingEndDuration === 'number' && orderTimeSettings.remainingEndDuration > 0
                ? orderTimeSettings.remainingEndDuration 
                : 0
        );

        useEffect(() => {
            if (endTimeRemaining <= 0) return;
            
            const id = setInterval(() => {
                setEndTimeRemaining(r => {
                    if (r <= 1) {
                        return 0;
                    }
                    return r - 1;
                });
            }, 1000);
            
            return () => clearInterval(id);
        }, [endTimeRemaining]); 

        const isTimedOut = endTimeRemaining === 0 || (orderTimeSettings?.remainingStartDuration > 0);
        return (

        <>
         {
                        isTimedOut
                        ? <OrderMenuTimeOut />
                        :

            <section className="main_content">
                <div id="DivContainer" className="container">
                    <OrderMenu />
                    <main>
                        <div className="tabs">
                            <div className="tab_links itemsPanel">
                                <ul>
                                    {menus.map((menu) => (
                                        <Menu key={menu.menuID} menu_id={menu.menuID} menu_name={menu.menuName} />
                                    ))}
                                </ul>
                            </div>
                            <Categories />
                            <Items />
                        </div>
                    </main>
                </div>
            </section>
 }
         </>
        );
    };

    return (
        <MenuProvider 
            key={`${data?.totalMonthPrice ?? 0}-${data?.totalPrice ?? 0}-${data?.menus?.length ?? 0}-${data?.userOrder?.orderId ?? ''}-${data?.orderTimeSettings?.startTime ?? ''}-${data?.orderTimeSettings?.endTime ?? ''}`}
            initialData={data} 
            onOrderSuccess={handleOrderSuccess}
        >
            <BodyContent />
        </MenuProvider>
     );
 };

 export default Body;